<div class="menu-container">
  <div class="modal-header-filters w-100 mb-3">
    <div class="modal-title">
      <span class="title-bottomsheet">Export</span>
    </div>
    <div class="modal-header-filters__right">
      <i class="close btn-close" (click)="onNoClick()"></i>
    </div>
  </div>
  <div class="mt-3 menu-content-mobile animate__animated animate__fadeIn">
    <button mat-menu-item (click)="onExportAll()">All</button>
    <button
      [disabled]="data.selectedItems.length <= 0"
      (click)="onExportSelected()"
      mat-menu-item
    >
      Selected Items
    </button>
  </div>
</div>
